import { React } from 'react';
import styled from 'styled-components';
import PrivacyModel from '../../Model/Individual/RulesModel/PrivacyModel';

function PrivacyPage() {
  
  return (
    <Container>
      <PrivacyModel/>
    </Container>
  )
}

export default PrivacyPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100vw;
`;